import { Box } from '@mui/material';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import BaseError from '@components/BaseError';

const DocumentNotFound: FC = () => {
    const { t } = useTranslation('common');

    return (
        <Box sx={{ pt: '10vh' }}>
            <BaseError
                logo="/assets/noResult.svg"
                subtitle={t('error.documentNotFound.subtitle')}
                title={t('error.documentNotFound.title')}
            />
        </Box>
    );
};

export default DocumentNotFound;
